import C from "../constants";

const initialState = {
  documentsList: [],
  documentsData: {},
  waitResponse: false,
  error: false,
};

export default function (state, action) {
  switch (action.type) {
    case C.GET_DOCUMENT:
    case C.DOWNLOAD_DOCUMENT:
    case C.DOCUMENT_SET_FOCUS:
    case C.DOCUMENT_REMOVE_FOCUS:
    case C.DOCUMENT_UPDATE:
    case C.DOCUMENT_REMOVE:
    case C.GET_DOCUMENT_OWNERS_LIST:
    case C.GET_DOCUMENT_CLIENTS_LIST:
      return {
        ...state,
        removed: false,
        updated: false,
        formErrors: undefined,
        updatedStatus: false,
      };
    case C.DOCUMENT_EDITOR_INIT:
      return {
        ...state,
        isDocumentInit: false,
      };
    case C.GET_DOCUMENTS_LIST_REQUEST:
    case C.GET_DOCUMENT_META:
      return {
        ...state,
        isLoad: true,
        formErrors: undefined,
      };
    case C.GET_DOCUMENTS_LIST_FAIL:
    case C.GET_DOCUMENT_FAIL:
    case C.DOWNLOAD_DOCUMENT_FAIL:
    case C.DOCUMENT_SET_FOCUS_FAIL:
    case C.DOCUMENT_REMOVE_FOCUS_FAIL:
    case C.DOCUMENT_UPDATE_FAIL:
    case C.DOCUMENT_REMOVE_FAIL:
    case C.GET_DOCUMENT_OWNERS_LIST_FAIL:
    case C.GET_DOCUMENT_CLIENTS_LIST_FAIL:
    case C.DOCUMENT_EDITOR_INIT_FAIL:
      const { formErrors } = action.error;
      return {
        ...state,
        isLoad: false,
        formErrors: formErrors || undefined,
      };
    case C.GET_DOCUMENTS_LIST_SUCCESS:
      const { documents, total, offset, order, direction, filters, search } =
        action.result;

      let documentsList = [...state.documentsList, ...documents];

      if (offset === 0) {
        documentsList = [...documents];
      }

      return {
        ...state,
        isLoad: false,
        documentsList: documentsList,
        total: total,
        order: order,
        direction: direction,
        filters: filters,
        search: search,
      };
    case C.DOCUMENT_CREATE_SUCCESS:
      if (!action.result) {
        return {
          ...state,
        };
      }
      const { document: createdDocument } = action.result;
      return {
        ...state,
        created: true,
        documentsData: {
          ...state.documentsData,
          [createdDocument.id]: {
            ...createdDocument,
          },
        },
        documentsList: [...state.documentsList, createdDocument],
      };
    case C.GET_DOCUMENT_SUCCESS:
      const { result: document } = action;
      return {
        ...state,
        created: true,
        documentsData: {
          ...state.documentsData,
          [document.id]: {
            ...state.documentsData[document.id],
            ...document,
          },
        },
        documentsList: [...state.documentsList],
      };
    case C.DOCUMENT_SET_FOCUS_SUCCESS:
    case C.DOCUMENT_REMOVE_FOCUS_SUCCESS:
      const { result } = action;
      return {
        ...state,
        documentsData: {
          ...state.documentsData,
          [result.documentId]: {
            ...state.documentsData[result.documentId],
            isDocumentFocus: result.isDocumentFocus,
          },
        },
      };
    case C.DOCUMENT_UPDATE_SUCCESS:
      const { id, data, updated, updatedStatus } = action.result;
      return {
        ...state,
        documentsData: {
          ...state.documentsData,
          [id]: {
            ...state.documentsData[id],
            ...data,
          },
        },
        documentsList: state.documentsList.reduce((res, d) => {
          if (d.id !== id) {
            res.push({
              ...d,
            });
          } else {
            res.push({
              ...d,
              ...data,
            });
          }
          return res;
        }, []),
        updated: updated,
        updatedStatus: updatedStatus,
      };
    case C.DOCUMENT_VERSION_CREATE_SUCCESS: {
      return {
        ...state,
        documentsData: {
          ...state.documentsData,
          [action.result.document.id]: {
            ...state.documentsData[action.result.document.id],
            ...action.result.document,
            versions: [
              ...state.documentsData[action.result.document.id].versions,
              action.result.createdDocumentVersion,
            ],
          },
          created: action.result.createdDocumentVersion,
        },
        documentsList: state.documentsList.reduce((result, document) => {
          if (document.id !== action.result.document.id) {
            result.push({
              ...document,
            });
          } else {
            result.push({
              ...document,
              ...action.result.document,
              versions: [
                ...state.documentsData[action.result.document.id].versions,
                action.result.createdDocumentVersion,
              ],
            });
          }
          return result;
        }, []),
      };
    }
    case C.NEW_DOCUMENT_VERSION_PUBLISH_SUCCESS:
      const {
        document: updatedDocument,
        updatedDocumentVersion: publishedDocumentVersion,
      } = action.result;

      const updatedVersions = state.documentsData[
        action.result.documentId
      ].versions.reduce((result, version) => {
        if (version.id === action.result.versionId) {
          result.push({
            ...version,
            ...publishedDocumentVersion,
          });
        } else {
          result.push(version);
        }
        return result;
      }, []);

      return {
        ...state,
        documentsData: {
          ...state.documentsData,
          [action.result.documentId]: {
            ...state.documentsData[action.result.documentId],
            ...updatedDocument,
            versions: [...updatedVersions],
          },
        },
        documentsList: state.documentsList.reduce((result, document) => {
          if (document.id !== action.result.documentId) {
            result.push({
              ...document,
            });
          } else {
            result.push({
              ...document,
              ...updatedDocument,
              versions: [...updatedVersions],
            });
          }
          return result;
        }, []),
      };
    case C.DOWNLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
      };
    case C.DOCUMENT_REMOVE_SUCCESS:
      const { id: docId } = action.result;
      return {
        ...state,
        documentsList: [
          ...state.documentsList.filter(
            (d) => docId.indexOf(d.id.toString()) === -1
          ),
        ],
      };
    case C.GET_DOCUMENT_OWNERS_LIST_SUCCESS:
      const { documentOwners } = action.result;
      return {
        ...state,
        documentOwners: documentOwners,
      };
    case C.GET_DOCUMENT_CLIENTS_LIST_SUCCESS:
      const { documentClients } = action.result;
      return {
        ...state,
        documentClients: documentClients,
      };
    case C.DOCUMENT_EDITOR_INIT_SUCCESS:
      const { result: res } = action;
      return {
        ...state,
        isDocumentInit: true,
        documentsData: {
          ...state.documentsData,
          [res.documentId]: {
            ...state.documentsData[res.documentId],
            editor: res.editor,
          },
        },
      };
    case C.GET_DOCUMENT_META_SUCCESS:
      const { templateId: templatingId, meta } = action.result;
      return {
        ...state,
        isLoad: false,
        documentsData: {
          ...state.documentsData,
          [templatingId]: {
            ...state.documentsData[templatingId],
            meta: meta,
          },
        },
      };
    default:
      return state || initialState;
  }
}
